import * as signalR from "@microsoft/signalr";
import { appInsights } from "./AppInsights";
import { format } from "date-fns";
import { getCurrentESTDate } from "./dateHelper";
import { GLOBALSETTINGS } from "../data/constants";

type WithTransport = {
    transport?: { name?: string };
};

export function getClientDetails(connection?: signalR.HubConnection) {
    const currentTime = format(getCurrentESTDate(), GLOBALSETTINGS.DATE_FORMAT_TIME);
    return {
        logTime: currentTime,
        username: localStorage.getItem("userName") ?? "Anonymous",
        connectionId: connection?.connectionId ?? "unknown",
        transport: (connection as signalR.HubConnection & WithTransport)?.transport?.name ?? "unknown",
        signalRClientVersion: signalR.VERSION,
        tlsVersion: typeof window !== "undefined" && "crypto" in window
            ? "TLS (browser default)"
            : "Unknown",
        userAgent: navigator.userAgent,
    };
}
export function logSignalRTrace(message: string,
    connection?: signalR.HubConnection,
    level: signalR.LogLevel = signalR.LogLevel.Trace) {
    const details = getClientDetails(connection);

    console.debug("[SignalR Trace]", message, details);

    if (level >= signalR.LogLevel.Error) {
        appInsights.trackTrace({
            message,
            severityLevel: 3,
            properties: details
        });
    }
}

export function attachSignalRLifecycleHandlers(
    connection: signalR.HubConnection
) {
    connection.onclose(error => {
        const msg = error
            ? `[SignalR] Connection closed with error: ${error.message}`
            : "[SignalR] Connection closed gracefully";
        logSignalRTrace(msg, connection, error ? signalR.LogLevel.Error : signalR.LogLevel.Information);
    });

    connection.onreconnecting(error => {
        const msg = error
            ? `[SignalR] Reconnecting due to error: ${error.message}`
            : "[SignalR] Attempting to reconnect...";
        logSignalRTrace(msg, connection, error ? signalR.LogLevel.Error : signalR.LogLevel.Information);
    });

    connection.onreconnected(connectionId => {
        const msg = `[SignalR] Reconnected successfully. ConnectionId: ${connectionId}`;
        logSignalRTrace(msg, connection);
    });
}
